import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { DocumentUploadContext } from "@shared-kernel/application/ports/shared/document-upload-provider";

type UploadDocumentPayload = DocumentUploadContext & { document: File };

export const uploadDocument = createApiThunk<string, UploadDocumentPayload>(
  "documents/uploadDocument",
  async (payload, { extra: { documentUploadProvider } }) => {
    const { document, ...context } = payload;
    return documentUploadProvider!.uploadDocument(document, context);
  },
);

export const resetUploadDocument = createAction("documents/resetUploadDocument");
